import { usePage } from '@inertiajs/react';

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import type { SharedData } from '@/types/shared';
import { getReceivedReviewsNotificationLabel } from './received-reviews-notification';

export function ReceivedReviewsIndicator() {
  const { newReceivedReviewsCount = 0 } = usePage<SharedData>().props;

  if (newReceivedReviewsCount <= 0) return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="ml-1 size-1.5 shrink-0 rounded-full bg-amber-500" />
      </TooltipTrigger>
      <TooltipContent>
        {getReceivedReviewsNotificationLabel(newReceivedReviewsCount)}
      </TooltipContent>
    </Tooltip>
  );
}
